import script from "./navigationHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./navigationHeader.vue?vue&type=script&setup=true&lang=js"

import "./navigationHeader.vue?vue&type=style&index=0&id=76440298&lang=scss&scoped=true"

import exportComponent from "/home/steffen/Projekte/clubadmin/frontend/homepage/gc-schoenbuch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76440298"]])

export default __exports__